import { SAVINGS_PLAN_SET_ENABLE_SAVE_BTN } from '../constants'

export function setEnableSaveBtn(value) {
    return dispatch => {
        dispatch({
            type: SAVINGS_PLAN_SET_ENABLE_SAVE_BTN,
            data: {
                enableSaveBtn: value
            }
        })
    }
}

export function reducer(state, action) {
    if (action.type === SAVINGS_PLAN_SET_ENABLE_SAVE_BTN) {
        return {
            ...state,
            ...action.data
        }
    }
    return state
}
